import src from "IMAGE";
export default { src, width: 600, height: 72, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADQ0NDtSUlJgV1dXZVxcXGtRUVFfUVFRXlFSUl9UVVVipRAKbo/3XnsAAAAASUVORK5CYII="};
